import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export function useInterval(callback, delay) {
  // Mirrors setInterval in a custom hook
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const withPolling =
  (pollingAction, affiliates = null, duration = 60000) =>
  Component => {
    const Wrapper = props => {
      useInterval(() => {
        props.pollingAction(affiliates);
      }, duration);

      return <Component {...props} />;
    };

    const mapStateToProps = () => ({});

    const mapDispatchToProps = { pollingAction };

    Wrapper.propTypes = {
      location: PropTypes.shape({
        search: PropTypes.string,
      }),
      pollingAction: PropTypes.func.isRequired,
    };

    Wrapper.defaultProps = {
      location: {
        search: '',
      },
    };

    return connect(mapStateToProps, mapDispatchToProps)(Wrapper);
  };

export default withPolling;
